var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsFaqArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "11pt",
    height: "18pt",
    viewBox: "0 0 11 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "cp0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,18)",
    d: "M 2.394041 18 L 1.030584 16.50646 L 8.209945 9 L 1 1.431525 L 2.424625 0 L 11 9 L 2.394041 18 Z ",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,18)",
    d: "M -4 23 L 16 23 L 16 -5 L -4 -5 Z ",
    fill: "#415055"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFaqArrow);
export default __webpack_public_path__ + "static/media/iconsFaqArrow.0572cdd9dd833c3cf51a3b934621f564.svg";
export { ForwardRef as ReactComponent };